import * as React from 'react';
import { Configure, Index } from 'react-instantsearch-core';
import { connectSortBy, connectRefinementList, connectRange, connectSearchBox } from 'react-instantsearch-dom';
import { FacetId } from '../../../types.js';
import { useAlgoliaConfig } from '../../AlgoliaConfig.js';

const noOp = ()=>null
;
const VirtualSortBy = connectSortBy(noOp);
const VirtualRefinementList = connectRefinementList(noOp);
const VirtualRange = connectRange(noOp);
const VirtualSearchBox = connectSearchBox(noOp);
const VirtualInfinitePagination = ({ pageSize , searchState  })=>{
    var ref;
    // On the server, set the offset so we start at the latest viewed page so only those results are fetched
    // E.G page=3 will result in offset=72 length=24
    const offset = ((ref = searchState.configure) === null || ref === void 0 ? void 0 : ref.offset) || 0;
    return /*#__PURE__*/ React.createElement(Configure, {
        offset: offset,
        length: pageSize
    });
};
/**
 * VirtualFacets should never render HTML
 */ const VirtualFacets = ()=>{
    const { facets , sortIndices , filters , pageSize , ruleContexts , algoliaInstantSearchProps: { searchState  } , facetingAfterDistinct , indices ,  } = useAlgoliaConfig();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Configure, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct
    }), indices && indices.length > 0 ? indices.map((name)=>/*#__PURE__*/ React.createElement(Index, {
            indexName: name,
            key: name
        })
    ) : null, sortIndices.length > 0 && sortIndices[0] && /*#__PURE__*/ React.createElement(VirtualSortBy, {
        defaultRefinement: sortIndices[0].value,
        items: sortIndices
    }), /*#__PURE__*/ React.createElement(VirtualInfinitePagination, {
        pageSize: pageSize,
        searchState: searchState
    }), /*#__PURE__*/ React.createElement(VirtualSearchBox, null), facets.map((facet)=>{
        switch(facet.id){
            case FacetId.price:
                return /*#__PURE__*/ React.createElement(VirtualRange, {
                    key: facet.attribute,
                    attribute: facet.attribute
                });
            default:
                return /*#__PURE__*/ React.createElement(VirtualRefinementList, {
                    key: facet.attribute,
                    attribute: facet.attribute,
                    defaultRefinement: facet.value,
                    limit: 100
                });
        }
    }), /*#__PURE__*/ React.createElement(Configure, {
        filters: filters,
        ruleContexts: ruleContexts
    }));
};

export { VirtualFacets as default };
//# sourceMappingURL=VirtualFacets.js.map
